import { embedDashboard } from "@superset-ui/embedded-sdk";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { useAppDispatch } from "../../../ReduxToolkit/Hooks";
import {
  getSupersetAssessmentReportsList,
  getSupersetReportsList,
} from "../../../ReduxToolkit/Reducers/MasterSlice";
import {
  DashboardNotFound,
  ErrorLoadingDashboard,
} from "../../../utils/Constant";
import { showToast } from "../../../utils/helper/helper";
import Header from "../../LearningAssessment/Header";
import "./style.scss";

const SUPERESET_BASE_URL = `${process.env.REACT_APP_SUPERSET_BASE_URL}`;

const GradeReports: React.FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const courseId = queryParams.get("course_id") || null;
  const assessmentId = queryParams.get("assessment_id") || null;
  const [selectedReportId, setSelectedReportId] = useState<string>("");

  const fetchGuestToken = async dashboardId => {
    const data = await dispatch(
      getSupersetAssessmentReportsList({
        type: courseId ? "course" : "assessment",
        dashboard_id: dashboardId,
        course_id: courseId,
        assessment_id: assessmentId,
      })
    );
    if (data?.payload?.guest_token && data?.payload?.guest_token !== "")
      return data?.payload?.guest_token;
  };

  const embedSelectedDashboard = async (dashboardId: string) => {
    try {
      const guestToken = await fetchGuestToken(dashboardId);

      if (!guestToken || guestToken === "") {
        showToast(DashboardNotFound, "error");
        return;
      }

      embedDashboard({
        id: dashboardId,
        supersetDomain: SUPERESET_BASE_URL,
        mountPoint: document.getElementById("superset-container")!,
        fetchGuestToken: () => guestToken,
        dashboardUiConfig: {
          filters: { visible: false, expanded: false },
          urlParams: {
            standalone: 0,
            id: 2,
          },
        },
      });

      const iframe = document.querySelector("iframe");
      if (iframe) {
        iframe.style.width = "100%";
        iframe.style.minHeight = "100vh";
      }
    } catch (error) {
      console.error(ErrorLoadingDashboard, error);
    }
  };

  useEffect(() => {
    getReports();
  }, [dispatch]);

  const getReports = async () => {
    const data = await dispatch(getSupersetReportsList({ type: "dashboard" }));
    const recievedData = data?.payload?.reports;
    if (recievedData && recievedData?.length > 0) {
      let dashboardId = "";
      let message = "Course Assessment Report";
      if (assessmentId) {
        message = "Assessment Report";
      }
      dashboardId = dashboardId = recievedData?.find(
        item => item?.name?.toString()?.trim() === message
      )?.dashboard_id;

      setSelectedReportId(dashboardId);
    }
  };

  useEffect(() => {
    if (selectedReportId && selectedReportId !== "") {
      embedSelectedDashboard(selectedReportId);
    }
  }, [selectedReportId]);

  return (
    <>
      <Header name={""} />
      <div className="report-dashboard-container">
        <div className="mt-4">
          <div id="superset-container" className="mt-4"></div>
        </div>
      </div>
    </>
  );
};

export default GradeReports;
